export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8754.ad3dfe0c.jpg";